import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRefresh1Line = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.92948 19.728C13.6058 20.713 17.3727 18.9698 19.0756 15.7379C19.333 15.2493 19.9378 15.0619 20.4264 15.3194C20.915 15.5768 21.1024 16.1816 20.845 16.6702C18.7162 20.7104 14.0099 22.8919 9.41185 21.6598C4.07718 20.2304 0.911365 14.747 2.34078 9.41234C3.7702 4.07768 9.25357 0.911852 14.5882 2.34127C18.592 3.41409 21.372 6.7697 21.9078 10.629C21.9669 11.0546 21.9988 11.4865 22.0021 11.9222C22.0086 12.8247 21.0065 13.3238 20.2893 12.8405L17.6157 11.0391C16.6076 10.3598 17.2836 8.78841 18.47 9.0532L19.5275 9.28923C18.6681 6.90982 16.6972 4.97694 14.0706 4.27312C9.80286 3.12959 5.41617 5.66225 4.27263 9.92997C3.1291 14.1977 5.66176 18.5844 9.92948 19.728Z"
	})
});
export default SvgRefresh1Line;
